var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mounted)?_c('div',{staticClass:"table"},[_c('vTable',{ref:"table",attrs:{"columns":_vm.columns,"data":_vm.columnsDataC},on:{"event":_vm.event}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }